import { useState, type FormEvent } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../app/providers.js';
import { isSignedIn } from '@plathunt/types';

export function Login() {
  const { signIn, state, authAvailable } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (isSignedIn(state)) return <Navigate to="/profile" replace />;

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError(null);

    if (!email.trim() || !password) {
      setError('Bitte E-Mail und Passwort ausfüllen.');
      return;
    }

    setBusy(true);
    const result = await signIn(email.trim(), password);
    setBusy(false);

    if (result.ok) navigate('/profile', { replace: true });
    else setError(result.message ?? 'Anmeldung fehlgeschlagen.');
  }

  return (
    <section className="ph-auth">
      <p className="ph-auth__kicker">PlatHunt Account</p>
      <h1 className="ph-screen__title">Anmelden</h1>

      {!authAvailable && (
        <p className="ph-notice ph-notice--error">
          Supabase ist nicht konfiguriert. Die App läuft auf DEV FIXTURES, eine Anmeldung ist hier
          nicht möglich.
        </p>
      )}

      {error && (
        <p className="ph-notice ph-notice--error" role="alert">
          {error}
        </p>
      )}

      <form onSubmit={submit} noValidate>
        <label className="ph-field">
          <span className="ph-field__label">E-Mail</span>
          <input
            className="ph-input"
            type="email"
            autoComplete="email"
            inputMode="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={busy || !authAvailable}
          />
        </label>

        <label className="ph-field">
          <span className="ph-field__label">Passwort</span>
          <input
            className="ph-input"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={busy || !authAvailable}
          />
        </label>

        <button className="ph-button" type="submit" disabled={busy || !authAvailable}>
          {busy ? 'Wird angemeldet …' : 'Anmelden'}
        </button>
      </form>

      <div className="ph-authlinks">
        <Link to="/register">Noch kein Konto? Account erstellen</Link>
        <Link to="/forgot-password">Passwort vergessen</Link>
        <Link to="/">Ohne Konto weitermachen</Link>
      </div>
    </section>
  );
}
